$ = require 'jquery'
EmojiProvider = require 'lib/emoji-provider'
TrelloEmoji = require 'views/emoji/trello-emoji'
Tooltip = require 'views/lib/tooltip'
React = require 'react'
ReactDOM = require 'react-dom'
ReactionTooltip = require 'views/reactions/reaction-tooltip'
View = require 'view'
t = require('views/internal/recup-with-helpers')('reactions')
trackUe = require 'debug/trackUe'
_ = require 'underscore'

availableEmoji = [
  '+1',
  '-1',
  'raised_hands',
  'pray',
  'eyes',
  'rocket',
  'joy',
  'blush',
  'heart_eyes',
  'trophy',
  'heart',
  'broken_heart'
]

reactionTemplate = t.renderable (reaction, selected) ->
  t.div '.select-reaction-list-item.js-toggle-reaction', {
    'data-reaction': reaction
    class: t.classify({ selected })
  }, ->
    t.addElement React.createElement TrelloEmoji,
      emoji: reaction

template = t.renderable ->
  t.div '.select-reaction-list', ->
    _.each availableEmoji, (emoji) ->
      reactionTemplate(emoji)

module.exports = class ReactionSelector extends View
  events:
    'click .js-toggle-reaction': 'handleReactionClick'
    'mouseenter .js-toggle-reaction': 'showReactionTooltip'
    'mouseleave .js-toggle-reaction': 'hideReactionTooltip'

  render: ->
    EmojiProvider.getIndex()
      .tap @renderLoading
      .then (index) =>
        @emojiIndex = index
        @renderReactDom()

    @

  renderLoading: =>
    ReactDOM.render(
      React.createElement('div', className: 'spinner loading'),
      @$el[0]
    )

  renderReactDom: =>
    ReactDOM.render(template(), @$el[0])

    @

  remove: ->
    ReactDOM.unmountComponentAtNode(@$el[0])
    super

  trackWithData: (verb, dirObj, prepObj, indObj, method) ->
    actionData = JSON.stringify
      actionId: @options.actionId

    trackUe("Reactions", verb, dirObj, prepObj, indObj, method, actionData)

  handleReactionClick: (e) ->
    $reactionEl = $(e.currentTarget)
    emojiShortname = $reactionEl.attr('data-reaction')
    emoji = @emojiIndex.search(emojiShortname)
      .filter((x) -> x.id == emojiShortname)
      .pop()

    trackFn = (isAdded) =>
      method =
        'by picking a reaction'
      @trackWithData(
        if isAdded then 'adds' else 'removes',
        'reaction',
        emoji.id,
        if isAdded then 'to a comment' else 'from a comment',
        method,
      )

    @hideReactionTooltip()
    @options.reactionList.toggleReaction(@options.actionId, emoji, trackFn)
    @options.onReactionClick && @options.onReactionClick(e)

  willBePopped: ->
    $('.js-open-reactions').removeClass 'active'

  showReactionTooltip: (e) ->
    $btn = @$(e.currentTarget)
    reaction = ":#{$btn.data 'reaction'}:"

    tooltipHtml = new ReactionTooltip { reaction }

    Tooltip.show(tooltipHtml, $btn, false, Tooltip.STYLE.MENU)

  hideReactionTooltip: ->
    Tooltip.hide()



// WEBPACK FOOTER //
// ./app/scripts/views/reactions/reaction-selector-limited.coffee